<template>
  <div class="editionpaybox" id="tac">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
             label-position="left">

      <div class="top">
        <div class="topcontent">
          <div class="topimg">
            <img src="../../public/statics/img/logo.jpg" alt="" @click="jumpediton()">
          </div>
          <div class="topright">
            <div class="topright1">
              IDA云物流
            </div>
            <div class="topright2">
              <div class="topright2s">
                智慧物流
              </div>
              <div class="topright2s">
                大数据
              </div>
              <div class="topright2s">
                企业赋能
              </div>
              <div class="topright2s">
                工业互联网
              </div>
              <div class="topright2s">
                柔性产线
              </div>
            </div>
            <div class="topright3">
              <div class="topright3s">
                <p>产品形态：</p>
                <span>集成产品</span>
              </div>
              <div class="topright3s">
                <p>付费模式：</p>
                <span style="color:#FBA962;">按租期</span>
              </div>

            </div>
          </div>
          <div style="font-size: 0.22rem;margin-left: auto;">
            详情请致电: <span style="color:#2394D2 ">400-008-0130转2</span>咨询
          </div>
        </div>
      </div>
      <div class="center">

        <div>
          <div v-if="puhuiyun!=1">
            <el-form-item label="买方公司:" prop="company" style="width: 620px">
              <el-input v-model="ruleForm.company"></el-input>
            </el-form-item>
            <div style="width:1020px;display: flex;justify-content: flex-start">
              <div style="width: 300px;margin-right: 10px;">
                <el-form-item label="联系人:" prop="name">
                  <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
              </div>
              <div style="width: 300px;margin-right: 10px;">
                <el-form-item label="联系电话:" prop="phone">
                  <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
              </div>
              <div style="display: flex;">
                <el-form-item label="验证码:" prop="code">
                  <el-input v-model="ruleForm.code" style="width: 120px;"></el-input>
                </el-form-item>
                <div v-show="cutshow==true" style="margin-left:10px;font-weight: bold;font-size: 14px;text-align: left;line-height: 40px;">{{ cutdown }}秒
                </div>
                <div v-show="cutshow==false" @click="getcode()" style="width: 100px;height: 40px;font-weight: bold;color:#3D68EB;font-size: 14px;cursor:pointer;line-height: 40px;">获取验证码
                </div>
                <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    content="购买后,联系人将成为管理员,联系电话将成为系统登录时的账号,请谨慎填写。">
                  <i slot="reference" class="el-icon-info"
                     style="font-size: 14px;line-height:40px;color:#fba962;"></i>
                </el-popover>
              </div>
            </div>
          </div>



          <div style="display: flex;justify-content: flex-start">
            <el-form-item :label="puhuiyun==1?'续费时长:':'购买时长度:'">
              <el-button type="primary">12个月</el-button>
            </el-form-item>
          </div>
        </div>


        <div v-for="(item,index) in alldata" :index="index">
          <div class="titles">
            <div class="font">
              {{ item.name }}
            </div>
            <div class="fontright">

              <div class="frunit">
                <p>服务模块:</p>
                <span>6000元</span>
              </div>
              <div class="frunit">
                <p>端口:</p>
                <span>免费</span>
              </div>
            </div>
          </div>

          <div class="children">
            <div>
              <el-form-item label="服务模块:">
                <div style="display: flex;">
                  <div v-for="(its,inds) in item.children" :index="inds" style="display: flex;margin-right: 0.2rem;">
                    <div class="model " :class="[its.focus==true ?'modelfocus':'']">
                      <p>{{ its.name }}</p>
                      <span>{{ its.price }}元/年</span>
                    </div>
                  </div>
                </div>

              </el-form-item>
              <el-form-item label="端口数:" style="position: relative">
                <span class="fivepay1">*</span>
                <div style="display: flex;justify-content: flex-start;align-items: center">
                  <el-input-number
                      disabled
                      v-model="item.sportnum" :min="item.sportnumlower"
                      label="描述文字"></el-input-number>
                  <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      content="免费提供有且只有1个端口。">
                    <i slot="reference" class="el-icon-info"
                       style="font-size: 24px;color:#fba962;margin-left: 0.2rem"></i>
                  </el-popover>
                </div>
              </el-form-item>
            </div>


          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="bots">
          <div class="bottom1">
            <div class="bot1unit">
              <p>服务模块费用合计：</p>
              <span>￥{{ modelall }}</span>
            </div>
            <div class="bot1unit">
              <p>端口费用合计：</p>
              <span>￥{{ sportall }}</span>
            </div>
            <div class="bot1unit" style="font-size: 0.2rem;">
              <p>总计：</p>
              <span>￥{{ all }}</span>
            </div>
          </div>
          <div class="bottom2">
            <el-button class="buttonclas" v-preventClick @click="purchase()"
                       style="width: 1.2rem!important;height: 0.45rem;font-size: 0.2rem;">{{puhuiyun==1?'立 即 续 费':'立 即 购 买'}}
            </el-button>
          </div>
        </div>
      </div>


      <el-dialog
          title="微信支付"
          :visible.sync="dialogVisible"
          width="560px"
          :before-close="handleClose">
          <div style="display: flex;justify-content: space-between">
            <div style="width: 300px;height: 333px;">
              <div id="qrCode" style="width: 250px;height: 250px;border: 1px solid #ccc;display: flex;align-items: center;justify-content: center;box-sizing: border-box"></div>
              <div style="display: flex;background:#64aa38;width: 250px;margin-top: 20px;padding: 10px;box-sizing: border-box">
                <img src="../../public/statics/img/editon/scan.png" alt="" style="width: 42px;margin-right: 4px;">
                <div style="display: flex;flex-direction: column;justify-content: flex-start;align-items: flex-start;color: #FFFFFF;">
                  <span>请使用微信扫一扫</span>
                  <span>扫描二维码支付</span>
                </div>
              </div>
            </div>
            <div style="width: 300px;height: 333px;overflow: hidden">
              <img style="width: 250px;"  src="../../public/statics/img/editon/wechat.png" alt="">
            </div>
          </div>
      </el-dialog>
      <el-dialog
          width="420px"
          :visible.sync="payvisible">
        <div style="display: flex;justify-content: space-between">
          <img src="../../public/statics/img/editon/paysucces.png" alt="" style="width: 32px;height: 32px;">
          <div style="display: flex;flex-direction:column;align-items: flex-start;text-align: left;margin-left: 10px;">
            <p style="line-height: 32px;font-size: 14px;font-weight: bold">付款成功,平台已为您创建账户!</p>
            <div>
              您可以点击下方的"登录系统"按钮,直接登录系统,或点击"返回"按钮返回官网首页。
            </div>
            <div style="margin-top: 10px;display: flex;justify-content: flex-end;align-items: flex-end;width: 100%;">
              <el-button type="info" size="small" @click="backindex">返回</el-button>
              <el-button type="primary" size="small" @click="loginsystem">登录系统</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-form>
  </div>

</template>

<script>
import {auth, anth} from '../request/api';
import QRCode from "qrcodejs2";//二维码生成
import {mapGetters} from "vuex";
export default {
  name: "editionpayp",
  computed: {
    ...mapGetters(['puhuiyun','t_id','tw_id']),
  },
  data() {
    return {
      transico: [
        {
          ico: require("../../public/statics/img/editon/t1.png"),
          name: '订单智能推荐'
        },
        {
          ico: require("../../public/statics/img/editon/t2.png"),
          name: '司机运力加盟'
        },
        {
          ico: require("../../public/statics/img/editon/t3.png"),
          name: '业务财务一体'
        },
        {
          ico: require("../../public/statics/img/editon/t4.png"),
          name: '直运管理'
        },
        {
          ico: require("../../public/statics/img/editon/t5.png"),
          name: '转运管理'
        },
        {
          ico: require("../../public/statics/img/editon/t6.png"),
          name: '配载管理'
        },
        {
          ico: require("../../public/statics/img/editon/t7.png"),
          name: '数据看板'
        },
        {
          ico: require("../../public/statics/img/editon/t8.png"),
          name: '智能调度'
        },
        {
          ico: require("../../public/statics/img/editon/t9.png"),
          name: '费用管理'
        },
      ],
      pacico: [
        {
          ico: require("../../public/statics/img/editon/p1.png"),
          name: '资产管理'
        },
        {
          ico: require("../../public/statics/img/editon/p2.png"),
          name: '租赁管理'
        },
        {
          ico: require("../../public/statics/img/editon/p3.png"),
          name: '循环管理'
        },
        {
          ico: require("../../public/statics/img/editon/p4.png"),
          name: '包装盘点'
        },
        {
          ico: require("../../public/statics/img/editon/p5.png"),
          name: '托管管理'
        },
        {
          ico: require("../../public/statics/img/editon/p6.png"),
          name: '费用管理'
        },
      ],

      ruleForm: {
        company: "",
        name: "",
        phone: "",
        code: '',//验证码
      },
      rules: {
        company: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur'},
          {
            pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|5|6|7|8|9)\d{9}))$/,
            message: '请输入正确的联系电话',
            trigger: 'blur'
          },
        ],
        code: [
          {required: true, message: '请输入联系人',},
        ],
      },
      /*普惠云服务模块*/
      alldata: [
        {
          name: "IDA普惠云",
          model: 0,//模块id
          sport: 0,
          sportprice: 0,
          sportnum: 1, //模块端口数
          sportnumlower: 1,
          children: [
            {
              id: 0, //服务模块内容id
              name: '基础管理模块',//模块服务名称
              price: 6000,//模块服务价格
              focus: true,
            }
          ],

        },

      ],
      modelall: 0,
      sportall: 0,
      all: 0,
      formout: 1,
      //购买逻辑
      timer: null,
      cutdown: 60,
      cutshow: false,
      dialogVisible:false,//购买展示
      payer:null,
      out_trade_no:'',//订单号
      payvisible:false
    }
  },
  created() {

  },
  mounted() {
    // this.getmodular();
    this.count();
  },
  methods: {
    getmodular() {
      let url = '/v1/website/offer/modular';
      auth(url).then(res => {
        if (res.data.code == 1) {
          let arr = JSON.parse(JSON.stringify(res.data.data));
          arr.forEach(v => {
            v.model = 0;//声明模块费用，
            v.sport = 0;//声明端口费用
            v.sportprice = 3600;//声明端口价格
            v.sportnumlower = Number(v.sportnumlower);
            v.sportnum = Number(v.sportnum);
            v.children.forEach(s => {
              s.sportnumlower = Number(s.sportnumlower);
              s.sportnum = Number(s.sportnum)
            })
          })
          // this.alldata=[arr[0]];

          if (this.$route.query.formout == 1) {
            this.alldata = [arr[0]];
          } else if (this.$route.query.formout == 2) {
            this.alldata = [arr[1]];
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          });
        }
      })
    },
    countser(index, inds, items) {
      if (items.modular == 'IDA云运输') {
        this.alldata[index].children[inds].focus = !this.alldata[index].children[inds].focus;
        if (this.alldata[index].children[inds].focus == false) {
          this.alldata[index].children.forEach(e => {
            e.focus = false;
          })
        }
      } else {
        this.alldata[index].children[inds].focus = !this.alldata[index].children[inds].focus;
        this.alldata[index].children[0].focus = true;
      }
      this.count();
    },
    count() {
      this.modelall = 0;
      this.sportall = 0;
      this.all = 0;
      this.alldata.forEach((e, i) => {
        let price = [];
        e.children.forEach(v => {
          if (v.focus == true) {
            price.push(Number(v.price));
          }
          if (e.modular == 'IDA云运输') {
            e.sportprice = 0;
          }
        });
        if (price.length != 0) {
          this.alldata[i].model = price.reduce((n, m) => n + m);//求和
          this.alldata[i].sport = Number(this.alldata[i].sportnum) * Number(this.alldata[i].sportprice);
        } else {
          this.alldata[i].model = 0;//求和
          this.alldata[i].sport = 0;
        }
        this.modelall += Number(e.model);
        this.sportall += Number(e.sport);

      });
      this.all = Number(this.modelall) + Number(this.sportall);

    },
    handleChange(index) {
      this.alldata[index].sport = Number(this.alldata[index].sportnum) * Number(this.alldata[index].sportprice);
      this.count();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.all == 0) {
            this.$message({
              type: 'warning',
              message: '请选择服务模块!'
            })
          } else {
            let arr = [];
            this.alldata.forEach(v => {
              let obj = {
                id: v.id,
                port: '',
                model: [],
              };
              v.children.forEach(s => {
                if (s.focus == true) {
                  obj.model.push(s.id);
                  obj.port = v.sportnum;
                }
              });
              arr.push(obj);
            });

            let url = '/v1/website/offer/apply';
            let data = {
              company_name: this.ruleForm.company,
              tel_name: this.ruleForm.name,
              phone: this.ruleForm.phone,
              buy_time: '12个月',
              //普惠云
              // inclusive:arr[0].model.toString(),
              // i_port:arr[0].port,
              // transport:arr[1].model.toString(),
              // t_port:arr[1].port,
              // packaging:arr[2].model.toString(),
              // p_port:arr[2].port,
              // warehouse:arr[3].model.toString(),
              // w_port:arr[3].port,
              modular_cost: this.modelall,
              port_cost: this.sportall,
              all_cost: this.all,
            };
            if (this.$route.query.formout == 1) {
              data.transport = arr[0].model.toString();
              data.t_port = arr[0].port;
            } else if (this.$route.query.formout == 2) {
              data.packaging = arr[0].model.toString();
              data.p_port = arr[0].port;
            }

            auth(url, data).then(res => {
              if (res.data.code == 1) {
                this.$message({
                  type: 'success',
                  message: '感谢您的购买，我们的销售人员会尽快联系您!',
                  duration: '300000',
                });
                // this.$router.push('/edition')
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            })

          }
        } else {
          this.$message({
            type: 'warning',
            message: '请完善您的信息!'
          })
          return false;
        }
      });
    },
    jumpediton() {
      this.$router.push('/edition')
    },
    //获取验证码
    getcode() {
      if (this.ruleForm.company == '') {
        this.$message.warning('请输入公司名称');
        return;
      }
      if (this.ruleForm.phone == '') {
        this.$message.warning('请输入联系电话');
        return;
      }
      let url = '/v1/website/offer/send_sms';
      let data = {
        t_name: this.ruleForm.company,
        phone: this.ruleForm.phone
      }
      auth(url, data).then(res => {
        if (res.data.code == 1) {
          this.$message.success('验证码发送成功!')
          this.cutshow = true;
          this.timer = setInterval(() => {
            this.cutdown--;
            if (this.cutdown == 0) {
              clearInterval(this.timer);
              this.timer = null;
              this.cutshow = false;
            }
          },1000)
        } else {
          this.$message(res.data.msg);
        }
      })
    },
    //立即购买  立即续费
    purchase(){
      //续费
      if (this.puhuiyun===1){
        let url='/v1/website/offer/renew';
        let data={
          t_id:this.t_id,
          tw_id:this.tw_id,
          duration:12,
        }
        auth(url,data).then(res=>{
          if (res.data.code==1){
            this.dialogVisible=true;
            this.bindQRCode(res.data.data.code_url);
            this.out_trade_no=res.data.data.out_trade_no;
            this.payer=setInterval(()=>{
              let url='/v1/website/offer/query_order';
              let data={
                out_trade_no:this.out_trade_no
              }
              auth(url,data).then(res=>{
                if (res.data.code==1){
                  if (res.data.data.status==1){
                    this.dialogVisible=false;
                    clearInterval(this.payer);
                    this.payer=null;
                    this.$alert('已为您续费成功!', '', {
                      confirmButtonText: '确定',
                      callback: action => {
                        this.$router.replace('index');
                      }
                    });
                  }
                }else{
                  clearInterval(this.payer);
                  this.payer=null;
                  this.$message(res.data.msg);
                }

              })
            },2000)

          }else{
            this.$message(res.data.msg);
          }
        })
      }
      //购买
      else{
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            let url='/v1/website/offer/buy';
            let data={
              t_name:this.ruleForm.company,
              tw_name:this.ruleForm.name,
              tw_phone:this.ruleForm.phone,
              duration:12,
              code:this.ruleForm.code
            }
            auth(url,data).then(res=>{
              if (res.data.code==1){
                this.dialogVisible=true;
                this.bindQRCode(res.data.data.code_url);
                this.out_trade_no=res.data.data.out_trade_no;
                this.payer=setInterval(()=>{
                  let url='/v1/website/offer/query_order';
                  let data={
                    out_trade_no:this.out_trade_no
                  }
                  auth(url,data).then(res=>{
                    if (res.data.code==1){
                      if (res.data.data.status==1){
                        this.payvisible=true;
                        this.dialogVisible=false;
                        clearInterval(this.payer);
                        this.payer=null;
                      }
                    }else{
                      clearInterval(this.payer);
                      this.payer=null;
                      this.$message(res.data.msg);
                    }

                  })
                },2000)
              }else{
                this.$message(res.data.msg)
              }
            })


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    handleClose(){
      if (this.payer){
        clearInterval(this.payer);
      }
      this.payer=null;
      this.dialogVisible=false;
    },
    //二维码
    bindQRCode(contents) {
      this.$nextTick(() => {
        let qrcodeEL = document.getElementById("qrCode");
        let qrcode = new QRCode(qrcodeEL);
        document.getElementById("qrCode").innerHTML = "";
        this.GetQRcode(contents);
      });
    },
    GetQRcode(e) {
      var qrcode = new QRCode("qrCode", {
        text: e, //  需要生成二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
    },
    //返回官网
    backindex(){
      this.$router.replace('index');
    },
    loginsystem(){
      window.location.replace(window.idomain)//正式环境
    },
  },
}
</script>

<style scoped lang='scss'>
.editionpaybox {
  width: 100%;
  height: 100vh;
  background: #F5F7FB;
  padding-bottom: 1rem;
  box-sizing: border-box;

  .top {
    width: 24rem;
    height: auto;
    background: #ffffff;
    position: fixed;
    top: 0;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);

    .topcontent {
      width: 18rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 1.6rem;

      .topimg {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 0.3rem;
        cursor: pointer;

        img {
          width: 100%;
        }
      }

      .topright {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-around;

        .topright1 {
          font-family: "PingFang SC";
          font-size: 0.35rem;
          margin-bottom: 0.05rem;
        }

        .topright2 {
          display: flex;

          .topright2s {
            width: auto;
            padding: 0 5px;
            height: 18px;
            line-height: 18px;
            font-size: 14px;
            color: #8AC7F8;
            border: 1px solid #8AC7F8;
            opacity: 1;
            border-radius: 100px;
            margin-right: 0.1rem;
          }
        }

        .topright3 {
          font-family: "PingFang SC";

          display: flex;
          margin: 0.1rem 0;

          .topright3s {
            width: 3rem;
            display: flex;
            font-size: 0.16rem;

            p {
              color: #999;
            }

            span {
              color: #333;
            }

          }
        }

      }
    }
  }

  .center {
    width: 18rem;
    position: fixed;
    top: 1.7rem;
    left: 0;
    right: 0;
    margin: auto;
    height: calc(100% - 2.4rem);
    /*height: 1500px;*/
    background: #ffffff;
    border-radius: 10px;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: scroll;

    .titles {
      width: 100%;
      box-sizing: border-box;
      height: 0.4rem;
      background: #F5F7FB;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;

      .font {
        font-size: 0.2rem;
        line-height: 0.4rem;
        text-align: left;
        padding: 0 0.1rem;
        font-family: "PingFang SC";
        color: #333;
      }

      .fontright {
        display: flex;

        .frunit {
          margin-right: 0.2rem;
          display: flex;
          font-size: 0.2rem;
          line-height: 0.4rem;
          text-align: left;
          padding: 0 0.1rem;
          font-family: "PingFang SC";
          color: #333;

          p {
            margin-right: 0.1rem;
          }

          span {
            color: #FF9A26
          }
        }
      }
    }

    .children {
      padding-top: 0.5rem;

      .model {
        width: 3.5rem;
        height: 0.5rem;
        border: 1px solid #999999;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        padding: 0 0.2rem;
        line-height: 0.5rem;
        box-sizing: border-box;
        font-family: "PingFang SC";
        cursor: pointer;
        overflow: hidden;
        //margin-right: 0.2rem;
        margin-bottom: 0.2rem;

        p {
          font-size: 0.2rem;
        }

        span {
          font-size: 0.16rem;
          color: #999999
        }
      }

      .modelfocus {
        border: 1px solid #4781F5;
        position: relative;
        box-sizing: border-box;
      }

      .modelfocus:before {
        position: absolute;
        right: 1px;
        bottom: 0;
        content: "✓";
        display: block;
        line-height: 0.2rem;
        z-index: 1;
        color: #ffffff;

      }

      .modelfocus:after {
        position: absolute;
        right: 0;
        bottom: 0;
        content: "√";
        color: #fff;
        display: block;
        width: 0;
        height: 0;
        border-bottom: 0.3rem solid #4781F5;
        border-left: 0.3rem solid transparent;
      }

      .fivepay {
        position: absolute;
        left: -100px;
        top: 15px;
        font-size: 0.1rem;
        color: #999;
      }

      .fivepay1 {
        position: absolute;
        left: -108px;
        top: 0.05rem;
        font-size: 0.2rem;
        color: #F35959;
      }


    }
  }

  .bottom {
    width: 24rem;

    background: #fff;
    position: fixed;
    bottom: 0;
    box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.09);

    .bots {
      width: 18rem;
      height: 48px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .bottom1 {

        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;

        .bot1unit {
          width: 5.25rem;
          display: flex;
          font-family: "PingFang SC";
          font-size: 0.15rem;
          line-height: 0.6rem;

          p {
            color: #333;
          }

          span {
            color: #FF9A26;
          }
        }
      }

      .bottom2 {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .buttonclas {
          height: 32px;
          padding: 5px;
          background: #FF9A26;
          color: #ffffff;
        }

        .buttonclas:hover {
          opacity: 0.8;
        }

        .buttonclas:active {
          opacity: 0.5;
          border: 1px solid #FBA962;
        }

      }

    }
  }


}
</style>
<style lang="scss">
.editionpaybox {
  .el-form-item__label {
    font-family: "PingFang SC";
    /*font-size: 0.24rem;*/
    color: #333;
  }

  .el-input-number .el-input__inner {
    pointer-events: none !important;
  }
}

</style>